import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-quotation-modal",
  templateUrl: "./quotation-modal.component.html",
  styleUrls: ["./quotation-modal.component.scss"],
})
export class QuotationModalComponent implements OnInit {
  quotationsList: any;
  selectedValue: string;

  constructor(
    public dialogRef: MatDialogRef<QuotationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.quotationsList = data.quotationsList;
    this.selectedValue = data.selectedValue;
  }

  ngOnInit(): void {}

  send() {
    this.dialogRef.close({ PK: this.selectedValue });
  }
}
